import { Component } from '@angular/core';

@Component({
  selector: 'app-rdsap-error',
  template: `
    <app-error-page
    title="Oops! Something went wrong."
    overrideErrorMessage="Hey, you are on a non-existent page. You need to give us an RRN on the query string."
    suggestion="Example: https://webserver/rdsap/5317-4329-0439-2107-8292">
  </app-error-page>
  `,
  styles: []
})
export class RdsapErrorComponent { }
